﻿import { getBreadCrumbImpression } from "./breadcrumb";
import { sendDataLayer } from "./ecommerce";

export const removeFromCartEcom = (orderLine: HTMLElement, quantity: number) =>
{
    quantity = Math.abs(quantity)

    sendDataLayer({
        'category': 'Ecommerce',
        'action': 'removeFromCart',
        'event': 'Click'
    });

    const breadcrumbs = getBreadCrumbImpression();
    const items = {};
    if ($(orderLine).attr("data-article-name") != '')
        items['item_name'] = $(orderLine).attr("data-article-name");
    if ($(orderLine).attr("data-article-ean") != '')
        items['item_id'] = $(orderLine).attr("data-article-ean");
    if ($(orderLine).attr("data-price") != '')
        items['price'] = $(orderLine).attr("data-price");
    if ($(orderLine).attr("data-discount") != '')
        items['discount'] = $(orderLine).attr("data-discount");
    items['currency'] = 'EUR';
    if ($(orderLine).attr("data-brand") != '')
        items['item_brand'] = $(orderLine).attr("data-brand");
    if ($(orderLine).attr("data-category") != '')
        items['item_category'] = $(orderLine).attr("data-category");
    if (breadcrumbs['item3'] != '')
        items['item_category2'] = breadcrumbs['item3'];
    if (breadcrumbs['item4'] != '')
        items['item_category3'] = breadcrumbs['item4'];
    if (breadcrumbs['item5'] != '')
        items['item_category4'] = breadcrumbs['item5'];
    if (breadcrumbs['item6'] != '')
        items['item_category5'] = breadcrumbs['item6'];
    if ($(orderLine).attr("data-variant") != '')
        items['item_variant'] = $(orderLine).attr("data-variant");
    if ($(orderLine).attr("data-color") != '')
        items['item_color'] = $(orderLine).attr("data-color");
    if ($(orderLine).attr("data-size") != '')
        items['item_size'] = $(orderLine).attr("data-size");
    if ($(orderLine).attr("data-livingstyle") != '')
        items['item_woonstijl'] = $(orderLine).attr("data-livingstyle");
    if ($(orderLine).attr("data-priceclass") != '')
        items['item_prijsklasse'] = $(orderLine).attr("data-priceclass");
    if ($(orderLine).attr("data-material") != '')
        items['item_materiaal'] = $(orderLine).attr("data-material");
    if ($(orderLine).attr("data-stuffing") != '')
        items['item_vulling'] = $(orderLine).attr("data-stuffing");
    if ($(orderLine).attr("data-season") != '')
        items['item_seizoen'] = $(orderLine).attr("data-season");
    if ($(orderLine).attr("data-deliverytime") != '')
        items['item_levertijd'] = $(orderLine).attr("data-deliverytime");
    if ($(orderLine).attr("data-articlenumber") != '')
        items['item_smulcode'] = $(orderLine).attr("data-articlenumber");
    if ($(orderLine).attr("data-sleepingposition") != '')
        items['item_slaaphouding'] = $(orderLine).attr("data-sleepingposition");
    if ($(orderLine).attr("data-firmness") != '')
        items['item_stevigheid'] = $(orderLine).attr("data-firmness");
    if ($(orderLine).attr("data-stock") != '')
        items['item_voorraad'] = $(orderLine).attr("data-stock");
    if ($(orderLine).attr("data-type") != '')
        items['item_type'] = $(orderLine).attr("data-type");
    if ($(orderLine).attr("data-thermalclass") != '')
        items['item_warmteklasse'] = $(orderLine).attr("data-thermalclass");
    items['item_list_id'] = '1';
    items['item_list_name'] = location.pathname;
    if ($(orderLine).attr("data-index") != '')
        items['index'] = $(orderLine).attr("data-index");
    items['quantity'] = '1';
    items['google_business_vertical'] = 'retail';

    sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
    sendDataLayer({
        'event': 'removeFromCart',
        'ecommerce': {
            'items': [items]
        }
    });
};

export const addToCartEcom = (orderLine: HTMLElement, quantity: number, productList: string = location.pathname) =>
{
    quantity = Math.abs(quantity)

    const breadcrumbs = getBreadCrumbImpression();
    const items = {};

    if (!$(orderLine).attr("data-article-name") && $(orderLine).closest("js-article")?.length > 0)
        orderLine = $(orderLine).closest("js-article-data")[0];

    if ($(orderLine).attr("data-article-name") != '')
        items['item_name'] = $(orderLine).attr("data-article-name");
    if ($(orderLine).attr("data-article-ean") != '')
        items['item_id'] = $(orderLine).attr("data-article-ean");
    if ($(orderLine).attr("data-price") != '')
        items['price'] = $(orderLine).attr("data-price");
    if ($(orderLine).attr("data-discount") != '')
        items['discount'] = $(orderLine).attr("data-discount");
    items['currency'] = 'EUR';
    if ($(orderLine).attr("data-brand") != '')
        items['item_brand'] = $(orderLine).attr("data-brand");
    if ($(orderLine).attr("data-category") != '')
        items['item_category'] = $(orderLine).attr("data-category");
    if (breadcrumbs['item3'] != '')
        items['item_category2'] = breadcrumbs['item3'];
    if (breadcrumbs['item4'] != '')
        items['item_category3'] = breadcrumbs['item4'];
    if (breadcrumbs['item5'] != '')
        items['item_category4'] = breadcrumbs['item5'];
    if (breadcrumbs['item6'] != '')
        items['item_category5'] = breadcrumbs['item6'];
    if ($(orderLine).attr("data-variant") != '')
        items['item_variant'] = $(orderLine).attr("data-variant");
    if ($(orderLine).attr("data-color") != '')
        items['item_color'] = $(orderLine).attr("data-color");
    if ($(orderLine).attr("data-size") != '')
        items['item_size'] = $(orderLine).attr("data-size");
    if ($(orderLine).attr("data-livingstyle") != '')
        items['item_woonstijl'] = $(orderLine).attr("data-livingstyle");
    if ($(orderLine).attr("data-priceclass") != '')
        items['item_prijsklasse'] = $(orderLine).attr("data-priceclass");
    if ($(orderLine).attr("data-material") != '')
        items['item_materiaal'] = $(orderLine).attr("data-material");
    if ($(orderLine).attr("data-stuffing") != '')
        items['item_vulling'] = $(orderLine).attr("data-stuffing");
    if ($(orderLine).attr("data-season") != '')
        items['item_seizoen'] = $(orderLine).attr("data-season");
    if ($(orderLine).attr("data-deliverytime") != '')
        items['item_levertijd'] = $(orderLine).attr("data-deliverytime");
    if ($(orderLine).attr("data-articlenumber") != '')
        items['item_smulcode'] = $(orderLine).attr("data-articlenumber");
    if ($(orderLine).attr("data-sleepingposition") != '')
        items['item_slaaphouding'] = $(orderLine).attr("data-sleepingposition");
    if ($(orderLine).attr("data-firmness") != '')
        items['item_stevigheid'] = $(orderLine).attr("data-firmness");
    if ($(orderLine).attr("data-stock") != '')
        items['item_voorraad'] = $(orderLine).attr("data-stock");
    if ($(orderLine).attr("data-type") != '')
        items['item_type'] = $(orderLine).attr("data-type");
    if ($(orderLine).attr("data-thermalclass") != '')
        items['item_warmteklasse'] = $(orderLine).attr("data-thermalclass");
    items['item_list_id'] = '1';
    items['item_list_name'] = productList;
    if ($(orderLine).attr("data-index") != '')
        items['index'] = $(orderLine).attr("data-index");
    items['quantity'] = '1';
    items['google_business_vertical'] = 'retail';

    sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
    sendDataLayer({
        'event': 'addToCart',
        'ecommerce': {
            'items': [items]
        }
    });
};

export const trackBasketPopUpClick = (type: string) =>
{
    sendDataLayer({
        'category': 'Ecommerce',
        'action': 'BasketPopUpClick',
        'label': type,
        'event': 'Click'
    });
}

(window as any).addToCartEcom = addToCartEcom;
(window as any).trackBasketPopUpClick = trackBasketPopUpClick;